import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpResponse } from '@angular/common/http';
import { apiEndpoints } from '../constants/api-endpoints';
import { IUserSelectEmail } from '../interfaces/user-select-email';
import { HttpUtilityService } from './http.utility.service';

@Injectable({
  providedIn: 'root',
})
export class UserSelectEmailService {
  constructor(private readonly httpUtilityService: HttpUtilityService) {}

  getAllList(filters: any): Observable<HttpResponse<IUserSelectEmail[]>> {
    const url = `${apiEndpoints.userSelectLoadEmail}${filters.cond}`;
    return this.httpUtilityService.get<any[]>(url);
  }
}
